import {createAction} from "@reduxjs/toolkit";

export const setSearchText = createAction('SET_SEARCH_TEXT');